import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, AlertCircle } from 'lucide-react';
import LOGO from '../assets/NYD-logo-footer.svg';

function Footer() {
  return (
    <footer className="bg-[#0A2540] text-white overflow-x-hidden">
      <div className="container mx-auto px-4 py-12 max-w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Columna 1: Información de la empresa */}
          <div className="lg:col-span-1">
            {/* Aviso legal */}
            <div className="bg-white/10 rounded-lg p-4 mb-6">
              <p className="text-xs text-gray-300 leading-relaxed">
                * Según Resolución 329/2020 ANAC el derecho de arrepentimiento no aplica para vuelos y estos se rigen por la política de devolución de la aerolínea.
              </p>
              <Link 
                to="/arrepentimiento"
                className="mt-3 w-full bg-white text-[#0A2540] px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-100 transition-colors block text-center"
              >
                Botón de arrepentimiento
              </Link>
            </div>

            {/* Logo e info */}
            <div className="mb-6">
              <div className="flex items-center mb-4">
                <img src={LOGO} alt="Noche y Día Turismo" className="h-10 w-auto" />
              </div>
              <p className="text-sm text-gray-300 leading-relaxed mb-4">
                <strong>Noche y Día Turismo</strong> es una empresa de Viajes desde 1993 con una importante trayectoria en el mercado turístico, que llega principalmente al pasajero a través de distintas instituciones o vendedores que nos confían sus asociados y/o clientes.
              </p>
            </div>

            {/* Contacto */}
            <div className="space-y-2 text-sm">
              <div className="flex items-start">
                <MapPin size={16} className="text-[#ff681f] mr-2 mt-1 flex-shrink-0" />
                <p className="text-gray-300">
                  Yerbal 1136 PB (C1406BWA), CABA, Argentina
                </p>
              </div>
              <div className="flex items-center">
                <Phone size={16} className="text-[#ff681f] mr-2 flex-shrink-0" />
                <a href="tel:01144328675" className="text-gray-300 hover:text-[#ff681f] transition-colors">
                  (011) 4432 8675
                </a>
              </div>
              <div className="flex items-center">
                <Mail size={16} className="text-[#ff681f] mr-2 flex-shrink-0" />
                <a 
                  href="mailto:consulta@nocheydiaturismo.com" 
                  className="text-gray-300 hover:text-[#ff681f] transition-colors break-all"
                >
                  consulta@nocheydiaturismo.com
                </a>
              </div>
            </div>

            {/* Licencia */}
            <div className="mt-4 pt-4 border-t border-white/10">
              <p className="text-xs text-gray-400">
                Noche y Día Turismo su Opción Turística de Marca Turística S.A. - <strong>EVT. 18.658</strong>
              </p>
              <p className="text-xs text-gray-400 mt-1">Licencia Habilitante</p>
            </div>

            {/* Horarios */}
            <div className="mt-6">
              <h4 className="font-semibold mb-3">Horarios de Atención</h4>
              <div className="text-sm text-gray-300 space-y-1">
                <p><strong>Lunes a Viernes</strong> de 10 a 13 hs y de 14 a 18hs</p>
                <p><strong>Sábados</strong> de 10 a 13hs</p>
              </div>
            </div>
          </div>

          {/* Columna 2: Destinos Parte 1 */}
          <div>
            <h3 className="text-lg font-bold mb-4">Nuestros Destinos</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/paquetes?destino=Bariloche" className="hover:text-[#ff681f] transition-colors">Bariloche</Link></li>
              <li><Link to="/paquetes?destino=Bariloche - El Bolsón - Esquel" className="hover:text-[#ff681f] transition-colors">Bariloche - El Bolsón - Esquel</Link></li>
              <li><Link to="/paquetes?destino=Búzios y Arraial Do Cabo" className="hover:text-[#ff681f] transition-colors">Búzios y Arraial Do Cabo</Link></li>
              <li><Link to="/paquetes?destino=Cabo Frío y Río de Janeiro" className="hover:text-[#ff681f] transition-colors">Cabo Frío y Río de Janeiro</Link></li>
              <li><Link to="/paquetes?destino=Calafate - Ushuaia" className="hover:text-[#ff681f] transition-colors">Calafate - Ushuaia</Link></li>
              <li><Link to="/paquetes?destino=Camboriú" className="hover:text-[#ff681f] transition-colors">Camboriú</Link></li>
              <li><Link to="/paquetes?destino=Catamarca y Termas de Fiambalá" className="hover:text-[#ff681f] transition-colors">Catamarca y Termas de Fiambalá</Link></li>
              <li><Link to="/paquetes?destino=Cataratas del Iguazú" className="hover:text-[#ff681f] transition-colors">Cataratas del Iguazú</Link></li>
              <li><Link to="/paquetes?destino=Chilecito - Termas de Fiambalá y Antofagasta" className="hover:text-[#ff681f] transition-colors">Chilecito - Termas de Fiambalá y Antofagasta</Link></li>
              <li><Link to="/paquetes?destino=Ciudades Imperiales y Polonia" className="hover:text-[#ff681f] transition-colors">Ciudades Imperiales y Polonia</Link></li>
              <li><Link to="/paquetes?destino=Esquel y Campo de Tulipanes" className="hover:text-[#ff681f] transition-colors">Esquel y Campo de Tulipanes</Link></li>
              <li><Link to="/paquetes?categoria=europa" className="hover:text-[#ff681f] transition-colors">Europa Turística</Link></li>
              <li><Link to="/paquetes?destino=Florianópolis" className="hover:text-[#ff681f] transition-colors">Florianópolis</Link></li>
              <li><Link to="/paquetes?destino=Glaciares y Chaltén" className="hover:text-[#ff681f] transition-colors">Glaciares y Chaltén</Link></li>
              <li><Link to="/paquetes?destino=Gramado - Canela" className="hover:text-[#ff681f] transition-colors">Gramado - Canela</Link></li>
              <li><Link to="/paquetes?destino=Jujuy y Humahuaca" className="hover:text-[#ff681f] transition-colors">Jujuy y Humahuaca</Link></li>
            </ul>
          </div>

          {/* Columna 3: Destinos Parte 2 */}
          <div>
            <h3 className="text-lg font-bold mb-4 opacity-0">Destinos</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/paquetes?destino=La Falda" className="hover:text-[#ff681f] transition-colors">La Falda</Link></li>
              <li><Link to="/paquetes?destino=Maceio" className="hover:text-[#ff681f] transition-colors">Maceio</Link></li>
              <li><Link to="/paquetes?destino=Maceio y Maragogi" className="hover:text-[#ff681f] transition-colors">Maceio y Maragogi</Link></li>
              <li><Link to="/paquetes?destino=Mar de Ajó" className="hover:text-[#ff681f] transition-colors">Mar de Ajó</Link></li>
              <li><Link to="/paquetes?destino=Mar del Plata" className="hover:text-[#ff681f] transition-colors">Mar del Plata</Link></li>
              <li><Link to="/paquetes?destino=Mar del Plata con Tandil" className="hover:text-[#ff681f] transition-colors">Mar del Plata con Tandil</Link></li>
              <li><Link to="/paquetes?destino=Maragogi" className="hover:text-[#ff681f] transition-colors">Maragogi</Link></li>
              <li><Link to="/paquetes?destino=Mendoza - San Rafael" className="hover:text-[#ff681f] transition-colors">Mendoza - San Rafael</Link></li>
              <li><Link to="/paquetes?destino=Mendoza con Termas de Cacheuta" className="hover:text-[#ff681f] transition-colors">Mendoza con Termas de Cacheuta</Link></li>
              <li><Link to="/paquetes?destino=Merlo" className="hover:text-[#ff681f] transition-colors">Merlo</Link></li>
              <li><Link to="/paquetes?destino=Natal y Pipa" className="hover:text-[#ff681f] transition-colors">Natal y Pipa</Link></li>
              <li><Link to="/paquetes?destino=Norte Argentino con Jujuy" className="hover:text-[#ff681f] transition-colors">Norte Argentino con Jujuy</Link></li>
              <li><Link to="/paquetes?destino=Porto Seguro y Arraial D'Ajuda" className="hover:text-[#ff681f] transition-colors">Porto Seguro y Arraial D'Ajuda</Link></li>
              <li><Link to="/paquetes?destino=Puerto Madryn" className="hover:text-[#ff681f] transition-colors">Puerto Madryn</Link></li>
              <li><Link to="/paquetes?destino=Ruta 40 al Sur" className="hover:text-[#ff681f] transition-colors">Ruta 40 al Sur</Link></li>
              <li><Link to="/paquetes?destino=Salta y Cafayate" className="hover:text-[#ff681f] transition-colors">Salta y Cafayate</Link></li>
              <li><Link to="/paquetes?destino=San Bernardo" className="hover:text-[#ff681f] transition-colors">San Bernardo</Link></li>
            </ul>
          </div>

          {/* Columna 4: Destinos Parte 3 */}
          <div>
            <h3 className="text-lg font-bold mb-4 opacity-0">Destinos</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/paquetes?destino=San Juan" className="hover:text-[#ff681f] transition-colors">San Juan</Link></li>
              <li><Link to="/paquetes?destino=San Juan y Calingasta" className="hover:text-[#ff681f] transition-colors">San Juan y Calingasta</Link></li>
              <li><Link to="/paquetes?destino=San Luis y Sierra de las Quijadas y La Carolina" className="hover:text-[#ff681f] transition-colors">San Luis y Sierra de las Quijadas y La Carolina</Link></li>
              <li><Link to="/paquetes?destino=San Martín con Esquel" className="hover:text-[#ff681f] transition-colors">San Martín con Esquel</Link></li>
              <li><Link to="/paquetes?destino=San Martín de los Andes" className="hover:text-[#ff681f] transition-colors">San Martín de los Andes</Link></li>
              <li><Link to="/paquetes?destino=San Rafael y Reyunos" className="hover:text-[#ff681f] transition-colors">San Rafael y Reyunos</Link></li>
              <li><Link to="/paquetes?destino=Talampaya - Valle de la Luna y Sierra de las Quijadas" className="hover:text-[#ff681f] transition-colors">Talampaya - Valle de la Luna y Sierra de las Quijadas</Link></li>
              <li><Link to="/paquetes?destino=Talampaya y Valle de la Luna" className="hover:text-[#ff681f] transition-colors">Talampaya y Valle de la Luna</Link></li>
              <li><Link to="/paquetes?destino=Termas de Federación" className="hover:text-[#ff681f] transition-colors">Termas de Federación</Link></li>
              <li><Link to="/paquetes?destino=Termas de Río Hondo" className="hover:text-[#ff681f] transition-colors">Termas de Río Hondo</Link></li>
              <li><Link to="/paquetes?destino=Ushuaia" className="hover:text-[#ff681f] transition-colors">Ushuaia</Link></li>
              <li><Link to="/paquetes?destino=Villa Carlos Paz" className="hover:text-[#ff681f] transition-colors">Villa Carlos Paz</Link></li>
              <li><Link to="/paquetes?destino=Villa Gesell" className="hover:text-[#ff681f] transition-colors">Villa Gesell</Link></li>
              <li><Link to="/paquetes?destino=Villa Giardino" className="hover:text-[#ff681f] transition-colors">Villa Giardino</Link></li>
            </ul>
          </div>
        </div>

        {/* Enlaces legales */}
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-400">
            <p>
              Defensa de las y los consumidores. Para reclamos{' '}
              <a 
                href="https://www.argentina.gob.ar/defensadelconsumidor" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#ff681f] hover:underline"
              >
                Aquí
              </a>
            </p>
            <span className="hidden md:inline">•</span>
            <p>
              Denuncia contra una agencia presione{' '}
              <a 
                href="https://www.argentina.gob.ar/turismo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#ff681f] hover:underline"
              >
                Aquí
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* ✅ Barra negra inferior - CORREGIDA PARA MOBILE */}
      <div className="bg-black py-4 overflow-x-hidden">
        <div className="container mx-auto px-4 max-w-full">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400 text-center md:text-left break-words max-w-full">
              © 2025 - Noche y Día Turismo su Opción Turística - EVT. 18.658
            </p>
            
            {/* ✅ Grid responsive para los enlaces */}
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:flex lg:flex-row gap-3 lg:gap-6 text-sm text-gray-400 w-full lg:w-auto">
              <Link to="/paquetes" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Destinos
              </Link>
              <Link to="/paginas/medios-de-pago" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Medios de Pago
              </Link>
              <Link to="/FAQ" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Información General
              </Link>
              <Link to="/paginas/condiciones-generales" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Condiciones Generales
              </Link>
              <Link to="/FAQ" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Preguntas Frecuentes
              </Link>
              <Link to="/contacto" className="hover:text-[#ff681f] transition-colors text-center lg:text-left">
                Contacto
              </Link>
              <a 
                href="https://vendeconnosotros.nocheydiaturismo.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#ff681f] transition-colors text-center lg:text-left col-span-2 sm:col-span-1"
              >
                Vendé con nosotros
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;